import { useLocation, useNavigate } from "react-router-dom";

function AdministrativeSettingsMenu({ children }) {
    const navigate = useNavigate();

    const location = useLocation();
    return (<>

        {children?.length > 0 && children.map((child) => (

            <div className="col-xxl-3 col-md-4 col-sm-6 col-12" key={child.id}>

                <div className="el-addministrative-setting">
                    <img src={child.image_path} className="img-fluid" alt="" />
                    <div className="el-flex-box">
                      <div className="el-min-height-content">

                        <h3>{child.name}</h3>
                        <p>{child.description}</p></div>
                        <button type="button" className="el-main-button"  onClick={() => {
    const pathParts = location.pathname.split("/");
    pathParts[pathParts.length - 1] = child.slug; // replace last segment
    const newPath = pathParts.join("/");
    navigate(newPath);
  }} > <span>View Details</span> </button>
                    </div>
                </div>
            </div>
        ))}
        {
            (children?.length === 0 || children == null) && <p>No Administrative Settings Available.</p>
        }
    </>);
}
export default AdministrativeSettingsMenu;